import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { AiService } from '../../../../service/ai.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-generic-result-view',
    standalone: false,
    templateUrl: './generic-result-view.component.html',
    styleUrl: './generic-result-view.component.scss'
})
export class GenericResultViewComponent implements OnInit {
    //   Injections
    aiService = inject(AiService);
    dialogRef = inject(MatDialogRef<GenericResultViewComponent>);
    data = inject(MAT_DIALOG_DATA);
    cd = inject(ChangeDetectorRef);
    private destroyRef = inject(DestroyRef);

    @Output() dataChanged = new EventEmitter<any>();

    isEditing: boolean = false;
    isLoading: boolean = false;
    backupData: any;

    ngOnInit(): void {
        this.backupData = JSON.parse(JSON.stringify(this.data.data));

        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Escape') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    async miroExport() {
        this.dialogRef.close({ type: "export-miro", resultData: this.data })
    }

    close() {
        if (this.isEditing) {
            // CANCEL after Editing was opend
            this.isEditing = false;
            this.data.data = JSON.parse(JSON.stringify(this.backupData));
        } else {
            // Closing when not editing Mode
            this.dialogRef.close({ type: "close", resultData: this.data })
        }
    }

    toggleEdit() {
        if (this.data.isCoachAccess === true) {
            return;
        }

        if (this.isEditing === true) {
            // Save after Editing Mode
            this.backupData = JSON.parse(JSON.stringify(this.data.data));
            this.isEditing = false;
            this.cd.detectChanges();
        } else {
            // Open editing Mode
            this.isEditing = true;
            this.cd.detectChanges();
        }
    }

    downloadAsPdf() {
        this.dialogRef.close({ type: "download-pdf", resultData: this.data })
    }
}

